import { NgClass, NgFor, NgIf } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { FirmService } from '../../../../Services/firm.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { UserServiceService } from '../../../../Services/user.service';
import { AuthService } from '../../../../Services/auth.service';
import { NotificationService } from '../../../../Services/notification.service';
import { CustomizeService } from '../../../../Services/Customize_settings/customize.service';

@Component({
  selector: 'app-kalakaar-header',
  imports: [NgIf, NgClass, NgFor, RouterLink, FormsModule],
  templateUrl: './kalakaar-header.component.html',
  styleUrl: './kalakaar-header.component.css'
})
export class KalakaarHeaderComponent implements OnInit {

  firmnames: string[] = [];
  selectedFirm: string | null | undefined;
  userImg: any;
  
  router = inject(Router);
  menuOpen = false;
  mobileExpanded: string | null = null;
   logoImage: any;

  // 1. HARDCODED MENU OPTIONS HERE
  navbarOptions = [
    {
      lable: 'Home',
      path: '/kalakaar-management/home',
      visible: true,
      submenu: []
    },
    {
      lable: 'Orders',
      path: '/kalakaar-management/order', // Update with your actual route path
      visible: true,
      submenu: []
    },
    {
      lable: 'Raw Material',
      path: '/kalakaar-management/raw-material', // Parent path
      visible: true,
      // Add submenu items here to make the dropdown appear
      submenu: []
    },
    {
      lable: 'Account',
      path: '/kalakaar-management/account',
      visible: true,
    },
  ];

  constructor(
    private firmService: FirmService,
    private firmSelectionService: FirmSelectionService,
    private userService:UserServiceService,
    private authService: AuthService,
    private notificationService: NotificationService,
    private customizeService: CustomizeService
    // private navService: NavbarService // Removed if no longer needed
  ) { }

  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }

  toggleSubmenu(path: string) {
    this.mobileExpanded = this.mobileExpanded === path ? null : path;
  }

  navigateTo(path: string) {
    this.router.navigate([path]);
    this.menuOpen = false;
    this.mobileExpanded = null;
  }

  ngOnInit(): void {
     // 🔥 Listen for logo changes
    this.customizeService.logo$.subscribe((logo) => {
      if (logo) {
        this.logoImage = logo;
      }
    });
    this.loadFirms();
    this.getProfile(this.authService.getUserId());
    
    // Subscribe to firm updates
    this.firmService.firmsUpdated$.subscribe(() => {
      this.loadFirms();
    });

    // 2. REMOVED the navService subscription block
    /* 
    this.navService.navbarOptions$.subscribe(options => {
      this.navbarOptions = options;
    }); 
    */
  }

  getProfile(id: any) {
    this.userService.getCurrentUserProfile(id).subscribe((res: any) => {
      this.userImg = res?.data?.[0]?.doc_user_img;
      console.log('check user img', this.userImg, res.data);
    });
  }

  onFirmChange(name: string) {
    this.firmService.getFirms().subscribe((response: any) => {
      const firm = response.data.find((f: any) => f.name === name);
      if (firm) {
        this.firmSelectionService.setselectedFirmName({ id: firm.id, name: firm.name, status: firm.gst_status, });
      }
    });
  }

  private loadFirms() {
    this.firmService.getFirms().subscribe((response: any) => {
      const firms = response.data;
      this.firmnames = firms.map((firm: any) => firm.name);

      let alreadySelectedFirm: any;
      this.firmSelectionService.selectedFirmName$.subscribe(firm => {
        alreadySelectedFirm = firm;
        if (firm) {
          this.selectedFirm = firm.name;
        }
      }).unsubscribe();

      if (!alreadySelectedFirm && firms.length > 0) {
        const storedFirmId = localStorage.getItem('firm_id');
        const storedFirm = firms.find((f: any) => f.id == storedFirmId);

        if (storedFirm) {
          this.selectedFirm = storedFirm.name;
          this.firmSelectionService.setselectedFirmName({ id: storedFirm.id, name: storedFirm.name,status: storedFirm.gst_status });
        } else {
          const defaultFirm = firms[0];
          this.selectedFirm = defaultFirm.name;
          this.firmSelectionService.setselectedFirmName({ id: defaultFirm.id, name: defaultFirm.name , status: defaultFirm.gst_status});
        }
      }
    });
  }

   isUserMenuOpen = false;

  toggleUserMenu(): void {
    this.isUserMenuOpen = !this.isUserMenuOpen;
  }

  onFocusOut(event: FocusEvent): void {
    const currentTarget = event.currentTarget as HTMLElement | null;
    const relatedTarget = event.relatedTarget as HTMLElement | null;

    if (!currentTarget) {
      this.isUserMenuOpen = false;
      return;
    }

    // ✅ Close only if focus moved outside the wrapper
    if (!relatedTarget || !currentTarget.contains(relatedTarget)) {
      this.isUserMenuOpen = false;
    }
  }

  logout(): void {
    this.isUserMenuOpen = false;
    this.notificationService.showSuccess(
      'Logged out successfully.',
      'Logout'
    );
    this.authService.logout();
  }
}